import React from 'react';
import { Select } from 'antd';
// Helpers
import { enumToLabel } from 'helpers/externalTalents';

const { Option } = Select;

type EnumSelectProps<T extends string> = {
  allowClear?: boolean;
  disabled?: boolean;
  options: T[];
  placeholder?: string;
  showSearch?: boolean;
  value?: T;
  onChange?: (value: T | undefined) => void;
};

const EnumSelect = <T extends string>({
  allowClear = false,
  disabled = false,
  options,
  placeholder,
  showSearch = false,
  value,
  onChange,
}: EnumSelectProps<T>): JSX.Element => {
  return (
    <Select
      allowClear={allowClear}
      disabled={disabled}
      onChange={onChange}
      optionFilterProp="children"
      placeholder={placeholder}
      showSearch={showSearch}
      value={value}
    >
      {options.map((option) => (
        <Option key={option} value={option}>
          {enumToLabel(option)}
        </Option>
      ))}
    </Select>
  );
};

export default EnumSelect;
